import { useEffect } from "react";
import { POST_MESSAGE_IN_TYPES, POST_MESSAGE_OUT_TYPES } from "../../../../../../../helpers/FeatureControlsHelper";
import { PROCESS_CUSTOMISATION_VARS_AND_INJECT_COLOURS } from "../../../../../../../helpers/Colours";

const lastParticles = {
    stringifiedSettings: null,
    refreshTimeout: null
}

const ParticleEffects = (props) => {
    console.log("ParticleEffects component with props:", props);
    const campaignData = props.campaignData;
    const featureData = props.node.featureData;

    const featureId = props.node?.parent?.id ?? props.node.id;
    const iframeId = props.overrideContainerId ? `${props.overrideContainerId}_iframe` : featureId;
    const customisationVars = props.node.customisationVars;
    const featureVars = {
        "featureControl": {
            "autoEnd": false,
            "autoEndDelay": 20
        },
        "featureURL": "/disruptor/particles/",
        "featureType": "disruptor",
        "featureName": "Particle Effects",
        "baseUrls": {
            "frontend": "http://localhost:3000",
            "backend": "http://localhost:5000"
        },
        "theme": {
            "id": ""
        }
    }

    const postMessageToFrame = (type, detail) => {
        const frameRef = document.getElementById(iframeId);
        if (frameRef) {
            console.log('Post to frame: ', iframeId, frameRef, type, detail);
            frameRef.contentWindow.postMessage({ type: type, detail: detail }, '*');

        }
    }

    const processPostedMessages = (event) => {
        console.log('ParticleEffects:  received message: ', event.origin, event.data);

        switch (event.data.type) {
            case POST_MESSAGE_IN_TYPES.HANDSHAKE:
                // respond that we are connected and ready!
                event.source.postMessage(
                    { type: POST_MESSAGE_OUT_TYPES.CONNECTED, detail: 'Howdy!' },
                    event.origin
                );
                // passFeatureCustomisationsToFeature(event.data.id);
                const customisationData = JSON.parse(JSON.stringify(customisationVars));
                // Disable the audio for the preview
                if (customisationData?.audio?.audio?.toggleSFX?.[0]) {
                    customisationData.audio.audio.toggleSFX[0].confettiPop = false;
                    customisationData.audio.audio.toggleSFX[0].explosions = false;
                    customisationData.audio.audio.toggleSFX[0].playBgAudio = false;
                    customisationData.audio.audio.toggleSFX[0].playEndAudio = false;
                    customisationData.audio.audio.toggleSFX[0].playStartAudio = false;
                    customisationData.audio.audio.toggleSFX[0].rocketFired = false;
                }
                PROCESS_CUSTOMISATION_VARS_AND_INJECT_COLOURS(customisationData, featureData, campaignData);
                postMessageToFrame(POST_MESSAGE_OUT_TYPES.CUSTOMISATION_VARS_RECEIVED, customisationData);
                break;
            case POST_MESSAGE_IN_TYPES.FEATURE_LOADED:
                postMessageToFrame(POST_MESSAGE_OUT_TYPES.SETTINGS_VARS_RECEIVED, featureVars);
                setTimeout(() => {
                    postMessageToFrame(POST_MESSAGE_OUT_TYPES.COMMAND_RECEIVED, { command: "START_PARTICLES", extraData: 0 });
                }, 100);
                break;
            default:
                console.log('ParticleEffects: Unhandled message type: ', event.data.type);
                break;
        }
                
    }
    const setUpPostMessageListener = () => {
        console.log("ParticleEffects: Setting up post message listener for Particle Effects iframe.");
        window.addEventListener(
            "message",
            processPostedMessages
        );
    }
    const removePostMessageListener = () => {
        console.log("ParticleEffects: Removing post message listener for Particle Effects iframe.");
        window.removeEventListener(
            "message",
            processPostedMessages
        );
    }
    useEffect(() => {
        setUpPostMessageListener();
        lastParticles.stringifiedSettings = JSON.stringify(customisationVars);
        return () => {
            removePostMessageListener();
            lastParticles.stringifiedSettings = null;
            clearTimeout(lastParticles.refreshTimeout);
            lastParticles.refreshTimeout = null;
        };
    }, []);

    // Detect changes whenever we re-render
    const newStringifiedSettings = JSON.stringify(customisationVars);
    if (lastParticles.stringifiedSettings !== null && newStringifiedSettings !== lastParticles.stringifiedSettings) {
        console.log("ParticleEffects: Detected customisationVars change, updating particle settings in iframe.");
        lastParticles.stringifiedSettings = newStringifiedSettings;
        if (lastParticles.refreshTimeout) {
            clearTimeout(lastParticles.refreshTimeout);
        }
        lastParticles.refreshTimeout = setTimeout(() => {
            // Reload our iframe
            const frameRef = document.getElementById(featureId);
            if (frameRef) {
                console.log("ParticleEffects: Reloading iframe to apply new settings.");
                frameRef.contentWindow.location.reload();
            }
        }, 1500);
    }

    return (
        <iframe
            title="Particle Effects Preview"
            id={iframeId}
            src={`/disruptor/particles/`}
            style={{ width: '100%', height: '100%', border: 'none' }}
        ></iframe>
    );
}

export default ParticleEffects;
